import { ColleagueFull, ColleagueInList, User } from "../types/users";

export const getUserFioShort = (user: User | ColleagueInList) => {
  const fio_array = [];
  if (user.last_name) {
    fio_array.push(user.last_name);
  }
  if (user.first_name) {
    fio_array.push(user.first_name[0] + ".");
  }
  if (user.middle_name) {
    fio_array.push(user.middle_name[0] + ".");
  }
  return fio_array.join(" ");
};

export const getUserFio = (user: User | ColleagueInList) => {
  const fio_array = [];
  if (user?.last_name) {
    fio_array.push(user.last_name);
  }
  if (user?.first_name) {
    fio_array.push(user.first_name);
  }
  if (user?.middle_name) {
    fio_array.push(user.middle_name);
  }
  return fio_array.join(" ");
};

export const getUserLastFirstName = (user: User | ColleagueInList) => {
  const fio_array = [];
  if (user?.last_name) {
    fio_array.push(user.last_name);
  }
  if (user?.first_name) {
    fio_array.push(user.first_name);
  }
  return fio_array.join(" ");
};

export const formatColleaguePostBrand = (
  colleague: ColleagueFull | undefined
) => {
  if (!colleague) {
    return "";
  }
  if (colleague.colleague_pk?.post && colleague.colleague_pk?.brand) {
    return `${colleague.colleague_pk?.post} / ${colleague.colleague_pk?.brand}`;
  }
  if (colleague.colleague_pk?.post) {
    return `${colleague.colleague_pk?.post}`;
  }
  if (colleague.colleague_pk?.brand) {
    return `${colleague.colleague_pk?.brand}`;
  }
  return "";
};

export const formatUserPostBrand = (user: User | undefined) => {
  if (!user) {
    return "";
  }
  if (user?.post && user?.brand) {
    return `${user?.post} / ${user?.brand}`;
  }
  if (user?.post) {
    return `${user?.post}`;
  }
  if (user?.brand) {
    return `${user?.brand}`;
  }
  return "";
};

export const filterUsersByIds = (users?: User[], ids?: string[]): User[] => {
  if (!users || !ids) {
    return [];
  }
  return users.filter((user) => ids.includes(user.pk));
};
